import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	title: {
		color: colors.yellow[400],
		fontSize: 16,
		fontWeight: "normal"
	},
	titleIcon: {
		color: colors.yellow[400]
	}
})

export default useStyles
